module.exports = __webpack_public_path__ + "media/images/aa-e748140932b618df113d1588bd26f068.svg";